import React, { createContext, useContext, useEffect } from 'react';

// إنشاء سياق الأمان
const SecurityContext = createContext(null);

// مزود سياق الأمان
export const SecurityProvider = ({ children }) => {
  useEffect(() => {
    // تطبيق التدابير الأمنية عند تحميل التطبيق
    applySecurityMeasures();
  }, []);

  // وظيفة تطبيق التدابير الأمنية
  const applySecurityMeasures = () => {
    // التحقق من أننا في وضع الإنتاج
    if (process.env.NODE_ENV === 'production') {
      // 1. إخفاء بيانات الاستدعاء والكائنات الحساسة
      obscureStackTrace();
      
      // 2. إخفاء البيانات الحساسة من localStorage
      secureLocalStorage();
      
      // 3. منع سحب البيانات الحساسة
      preventDataExfiltration();
      
      // 4. التحقق من تعديلات الأمان الدورية
      setupSecurityChecks();
      
      // 5. حماية مفاتيح API المكشوفة (جديد)
      protectApiKeys();
      
      // 6. منع نسخ المفاتيح من DOM (جديد)
      preventKeysCopying();
      
      // 7. منع التفتيش على العناصر (جديد)
      preventElementInspection();
    }
  };

  // إخفاء مسار التتبع للأخطاء
  const obscureStackTrace = () => {
    try {
      // تجاوز Error للأخطاء لإخفاء المسارات
      const originalError = Error;
      window.Error = function (message) {
        const error = new originalError(message);
        if (error.stack) {
          Object.defineProperty(error, 'stack', {
            get: function () {
              return 'Error: ' + message;
            }
          });
        }
        return error;
      };
      window.Error.prototype = originalError.prototype;
    } catch (e) {
      // تجاهل الأخطاء
    }
  };

  // تأمين التخزين المحلي
  const secureLocalStorage = () => {
    try {
      // إخفاء قيم التخزين المحلي الحساسة
      const sensitiveKeys = ['token', 'apiKey', 'authToken', 'firebaseToken'];
      
      // منع الوصول المباشر للبيانات الحساسة
      const originalGetItem = localStorage.getItem;
      localStorage.getItem = function(key) {
        if (sensitiveKeys.includes(key)) {
          return '****[محمي]****';
        }
        return originalGetItem.apply(this, arguments);
      };
      
      // حماية setItem أيضًا لتشفير البيانات الحساسة
      const originalSetItem = localStorage.setItem;
      localStorage.setItem = function(key, value) {
        // يمكن إضافة تشفير هنا إذا لزم الأمر
        return originalSetItem.apply(this, arguments);
      };
    } catch (e) {
      // تجاهل الأخطاء
    }
  };

  // منع تسريب البيانات
  const preventDataExfiltration = () => {
    try {
      // منع النسخ للبيانات الحساسة
      document.addEventListener('copy', function(e) {
        // التحقق مما إذا كان المحتوى المنسوخ يحتوي على بيانات حساسة
        const selection = document.getSelection().toString();
        if (selection.includes('apiKey') || selection.includes('token') || selection.includes('Key')) {
          e.preventDefault();
        }
      });
      
      // منع فتح وحدة تحكم المتصفح
      function detectDevTools() {
        // محاولة تتبع حدث توقف عند النقطة
        debugger;
      }
      
      // تنفيذ فحص دوري
      if (typeof setInterval !== 'undefined') {
        setInterval(detectDevTools, 1000);
      }
    } catch (e) {
      // تجاهل الأخطاء
    }
  };

  // إعداد فحوصات أمنية دورية
  const setupSecurityChecks = () => {
    try {
      // فحص دوري للتأكد من عدم التلاعب بآليات الأمان
      setInterval(() => {
        // التحقق من سلامة النسخة المعدلة من console.log
        if (window.console && window.console.log.toString().length < 50) {
          // استعادة الحماية إذا تم التلاعب بها
          console.log = function() {};
        }
      }, 5000);
    } catch (e) {
      // تجاهل الأخطاء
    }
  };
  
  // حماية مفاتيح API المكشوفة (جديد)
  const protectApiKeys = () => {
    try {
      // تعريف كائن env.js وحمايته
      if (window.ENV_CONFIG) {
        // منع تعديل كائن ENV_CONFIG
        Object.freeze(window.ENV_CONFIG);
        
        // منع عرض محتوى الدوال في وحدة التحكم
        const protectFunction = (obj, funcName) => {
          if (obj && typeof obj[funcName] === 'function') {
            const originalFunc = obj[funcName];
            Object.defineProperty(obj, funcName, {
              get: function() {
                return function() {
                  return originalFunc.apply(obj, arguments);
                };
              },
              configurable: false
            });
          }
        };
        
        // حماية الوظائف الحساسة
        protectFunction(window.ENV_CONFIG, 'getFirebaseConfig');
        protectFunction(window.ENV_CONFIG, 'getGoogleMapsKey');
        protectFunction(window.ENV_CONFIG, 'isAuthorizedDomain');
      }
      
      // إخفاء/منع عناصر تحتوي على مفاتيح API في HTML
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // البحث عن عناصر script التي تحتوي على مفاتيح API
            const scripts = document.querySelectorAll('script[src*="key="]');
            scripts.forEach((script) => {
              // استبدال مفتاح API في src بقيمة مشفرة
              if (script.src && script.src.includes('key=')) {
                const srcWithoutKey = script.src.replace(/(key=)([^&]*)/, '$1***PROTECTED***');
                script.setAttribute('src-secure', srcWithoutKey);
                // عدم حذف الأصلي لتجنب كسر الوظائف
              }
            });
          }
        });
      });
      
      // بدء مراقبة تغييرات DOM
      observer.observe(document, { childList: true, subtree: true });
    } catch (e) {
      // تجاهل الأخطاء
    }
  };
  
  // منع نسخ المفاتيح من DOM (جديد)
  const preventKeysCopying = () => {
    try {
      // إضافة حدث لمنع اختيار النص في عناصر script
      document.addEventListener('selectstart', function(e) {
        const target = e.target;
        if (target && (
          (target.tagName === 'SCRIPT') || 
          (target.outerHTML && target.outerHTML.includes('key='))
        )) {
          e.preventDefault();
          return false;
        }
      });
      
      // منع النسخ من console.log
      const originalLog = console.log;
      console.log = function() {
        // فحص إذا كانت المعلومات تحتوي على مفاتيح حساسة
        const sensitivePattern = /(api[-_]?key|firebase|key=|token)/i;
        for (let i = 0; i < arguments.length; i++) {
          const arg = arguments[i];
          if (typeof arg === 'string' && sensitivePattern.test(arg)) {
            arguments[i] = '[معلومات محمية]';
          } else if (typeof arg === 'object' && arg !== null) {
            // محاولة فحص الكائنات
            try {
              const stringified = JSON.stringify(arg);
              if (sensitivePattern.test(stringified)) {
                arguments[i] = { protected: true, message: 'تم حماية البيانات الحساسة' };
              }
            } catch (e) {
              // تجاهل أخطاء التحويل
            }
          }
        }
        return originalLog.apply(console, arguments);
      };
    } catch (e) {
      // تجاهل الأخطاء
    }
  };
  
  // منع التفتيش على العناصر (جديد)
  const preventElementInspection = () => {
    try {
      // منع النقر بالزر الأيمن
      document.addEventListener('contextmenu', function(e) {
        // منع النقر بالزر الأيمن فقط على عناصر script وعناصر أخرى حساسة
        if (e.target.tagName === 'SCRIPT' || 
            (e.target.outerHTML && e.target.outerHTML.includes('key='))) {
          e.preventDefault();
        }
      });
      
      // منع فتح أدوات المطور عبر النقر على عناصر DOM
      document.addEventListener('click', function(e) {
        if (e.detail === 3 && (e.altKey || e.ctrlKey)) {
          e.preventDefault();
        }
      });
      
      // منع سحب العناصر
      document.addEventListener('dragstart', function(e) {
        if (e.target.tagName === 'SCRIPT') {
          e.preventDefault();
        }
      });
    } catch (e) {
      // تجاهل الأخطاء
    }
  };

  return (
    <SecurityContext.Provider value={{ isSecure: true }}>
      {children}
    </SecurityContext.Provider>
  );
};

// Hook لاستخدام سياق الأمان
export const useSecurity = () => useContext(SecurityContext);

export default SecurityContext; 